import React from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
export function TrustBar() {
  return <section className="bg-white border-y border-divider py-5 px-4" data-id="element-154">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center space-y-3 md:space-y-0 md:space-x-8 lg:space-x-12" data-id="element-155">
        <div className="flex items-center space-x-2 font-sans text-sm md:text-base text-muted-foreground" data-id="element-156">
          <span className="font-medium text-espresso" data-id="element-157">250+</span>
          <span data-id="element-158">Reviews</span>
        </div>

        <div className="hidden md:block w-px h-4 bg-divider" aria-hidden="true" data-id="element-159" />

        <div className="flex items-center space-x-2 font-sans text-sm md:text-base text-muted-foreground" data-id="element-160">
          <span className="font-medium text-espresso" data-id="element-161">4.9</span>
          <div className="flex items-center text-gold" data-id="element-162">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-163" />)}
          </div>
          <span data-id="element-164">Stars</span>
        </div>

        <div className="hidden md:block w-px h-4 bg-divider" aria-hidden="true" data-id="element-165" />

        <div className="flex items-center space-x-2 font-sans text-sm md:text-base text-muted-foreground" data-id="element-166">
          <MapPinIcon className="w-4 h-4 text-sage" data-id="element-167" />
          <span data-id="element-168">San Ramon, CA</span>
        </div>
      </div>
    </section>;
}